export default {
  primary: '#3c3b54',
  secondary: '#5D92F4',
  accent: '#A5A4BF',
  error: '#fd5b46',
  info: '#00D0BD',
  success: '#00AD85',
  warning: '#FFB70F'
}



// WEBPACK FOOTER //
// ./src/constants/primaryTheme.js